var aspectRatio = 16 / 8;

// İletileri işlemek için bir fonksiyon
function handleMessage(event) {
    if (event.data && event.data.for === 'iframeResize') {
        aspectRatio = event.data.aspectRatio;

        // İlk kez boyutu ayarlayalım
        resizeIframe();
    }
}

// iframe'ın yüksekliğini ayarlayan fonksiyon
function resizeIframe() {
    const iframe = document.querySelector('#embeddedIframe');

    if (iframe) {
        const width = iframe.offsetWidth;

        if (aspectRatio) {
            iframe.style.height = (width / aspectRatio) + 'px';
        }
    }
}

// Pencere boyutu değiştiğinde iframe yüksekliğini güncelle
window.addEventListener('resize', resizeIframe);

// iframe'den gelen iletileri dinle
window.addEventListener('message', handleMessage, false);

function NewsletterPopupControl() {
    if ($.cookie('NewsletterPopup') != "undefined" && $.cookie('NewsletterPopup') != "false") {
        $.ajax({
            type: 'get',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/User/UserCheck",
            success: function (dt) {
                if (dt.USER == -1 && $("#SmallLangCode").val() == "tr") {
                    $("#NewsletterPopup").modal();
                }
            }
        });

    }

    $('#NewsletterPopup').on('hidden.bs.modal', function () {
        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);

        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
        $(".NewsLetterResult").hide();
        $(".NewsletterFormHead").show();
    })


    $("#IgnoreLink > a,.DialogClose").live("click", function () {

        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
        $("#NewsletterPopup").modal("hide");

    });


    $("#newsletterFormSubmit").live("click", function () {
        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
    });

}

function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}

function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")
    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")
    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }

}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }


                }
            }
            settingTextBanner();
        }
    });


}

function RememberCheck() {
    $(".RememberCheck #cbox").on("change", function () {
        if ($(this).prop("checked")) {
            $(".RememberCheck .customCheck").addClass("checked");
        } else {
            $(".RememberCheck .customCheck").removeClass("checked");
        }
    });
}

$(document).ready(function () {

    //HomeCatalogTabs();
    //GetLayoutTextBanners()
    RememberCheck();
    resizeIframe();

    if ($(window).width() < 767) {
        HometabSlider();
    }
    else {
        HomeSlick();
    }

    HomeSuggestedPrdsSlider();
    ContentPageSlider()

    if ($(window).width() > 992) {
        // NewsletterPopupControl();
    }
    else {
        $("#NewsletterPopup").modal("hide");
    }

    // Home Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });

    if ($(window).width() > 992 && $(".video-banner-mobile-area").length > 0) {
        $(".video-banner-mobile-area").remove();
    }
    else if ($(window).width() < 991 && $(".video-banner-desktop-area").length > 0) {
        $(".video-banner-desktop-area").remove();
    }

    if ($(window).width() > 992 && $(".video-banner-desktop-area").length > 0) {

        $(".video-banner-desktop-area").show();
        $(".video-banner-mobile-area").hide();
    }
    else if ($(window).width() < 991 && $(".video-banner-mobile-area").length > 0) {


        $(".video-banner-mobile-area").show();
        $(".video-banner-desktop-area").hide();
    }

    $("body").off("submit").on("submit", "form.ContactForm , form.AdvantageForm,form.DealerForm", function (e) {

        $form = $(this);
        if ($(".AvdInput button").length > 0) {
            $(".AvdInput button").text("gönderiliyor lütfen bekleyiniz.");
        }
        if ($(".SendFormButton .btn").length > 0) {
            //$(".SendFormButton .btn").val("gönderiliyor lütfen bekleyiniz.");
            $(".SendFormButton .btn").hide();
            $(".SendFormButton .controls").addClass("alert alert-block alert-success").html("Gönderiliyor lütfen bekleyiniz.");
        }


        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    //$form.hide();
                    $(".SendFormButton .controls").addClass("alert alert-block alert-success").html("Başvuru Gönderildi");
                    $(".SendFormButton .btn").show();
                }
                else {

                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);

                    $(".SendFormButton .btn").show();
                    $(".SendFormButton .controls").removeClass("alert alert-block alert-success").html("<input type='submit' class='btn btn-large' name='' value='BAŞVURU GÖNDER'>");
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        e.preventDefault();
        return false;

    });

    if (isMobile(false) && isAppleMobile() && !IsAndroid()) {

        $(".HomeSuggestPrdArea .TitleSuggest h3").css("margin-bottom", "10px");
    }

    if ($(".HomeProducts").length > 0) {

        //$("#HomeCatalogTabs .ProductList .Prd").removeClass("col-md-4");
        //$("#HomeCatalogTabs .ProductList .Prd").addClass("col-md-6");

        $(".HomeProducts div.Prd > a").each(function (index) {

            var imgBG = $(this).find("img:first").attr("src");

            if (imgBG.indexOf("404") != -1 && $(this).find("img:first").attr("data-qazy-src") != undefined) {
                imgBG = $(this).find("img:first").attr("data-qazy-src");
            }

            $(this).css("background-image", "url(" + imgBG + ")");
            $(this).parent().append("<a href='" + $(this).attr("href") + "' class='GotoDetails'>" + $("#GotoDetailsVl").val() + "</a>");

        });
    }

    if (!isMobile(true)) {

        $("#CatalogTabs > li").live({
            mouseenter:
                function () {

                    $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
                    $(this).addClass("active");



                    $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

                },
            mouseleave:
                function () {


                }
        });

        if ($("#CatalogTabs li[data-id='173']").length > 0) {

            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $("#CatalogTabs > li").removeClass("active");

            $("#CatalogTabs li[data-id='173']").addClass("active");
            var index = $("#CatalogTabs li[data-id='173']").index();
            $("#HomeCatalogContens > div").eq(index).addClass("active");

        }
    }

    $("#CatalogTabs li").live("click", function () {

        var href = $("#MainMenu li a[data-rel='" + $("#CatalogTabs li.active").data("id") + "']").attr("href");


        if (!isMobile(true)) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        } else if ($(this).hasClass("active")) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        }
        else {
            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $(this).addClass("active");
            $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");
        }

    });

    function ContentPageSlider() {
        $('.LandingPageCorporate .corporate-content').slick({
            nextArrow: '<div class="PrdImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdImgLeft left-arrow"></div>',
            infinite: true,
            slidesToShow: 3,
            arrows: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });
    }


    function HometabSlider() {

        // $("#HomeCatalogContens img.img2").remove();

        $("#HomeCatalogContens .HomeProducts.HomeTabItem .ProductList").slick({
            nextArrow: '<div class="PrdHomeImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdHomeImgLeft left-arrow"></div>',
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            useTransform: false,
            touchMove: false,
            swipe: false
        });

        $("#HomeCatalogContens .HomeProducts.HomeTabItem .newSlick").slick({
            //nextArrow: '<div class="PrdHomeImgRight right-arrow"></div>',
            //prevArrow: '<div class="PrdHomeImgLeft left-arrow"></div>',
            slidesToScroll: 1,
            arrows: false,
            useTransform: false,
            dots: true,
            dotsClass: 'slick-indicators visible-xs'
        });
    }

    function HomeSlick() {
        $("#HomeCatalogContens .HomeProducts.HomeTabItem .newSlick").slick({
            nextArrow: '<div class="PrdListImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdListImgLeft left-arrow"></div>',
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
            useTransform: false

        });
    }

    function HomeSuggestedPrdsSlider() {
        var valueSlidesToShow = 4;

        if ($(window).width() < 767) {
            valueSlidesToShow = 2;
        }
        $(".HomeSuggestPrdArea .ProductList").slick({
            nextArrow: '<div class="PrdHomeImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdHomeImgLeft left-arrow"></div>',
            slidesToShow: valueSlidesToShow,
            slidesToScroll: 1,
            arrows: true,
            useTransform: false,
        });

    }

    $("#pieceBanner1, .pieceBannerMiddle1 , .pieceBannerRight1 , .pieceBannerMiddle2 , .pieceBannerRight2 ").live("click", function () {

        var href = $(this).find(".middleText").find("a").first().attr("href");

        if (href != undefined && href != null) {

            document.location.href = href;
        }

    });


    //$("#CookieNotificationArea .CookieLink > #CookieCloseBtn").click(function () {

    //    $("#CookieNotificationArea").css("display", "none");
    //    $("footer #Legal").css("margin-bottom", "0px");

    //});

    //function GetLastVisitedProducts() {

    //    if ($(".AutoGetLastVisited").length > 0) {

    //        $.ajax({
    //            type: "GET",
    //            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProducts?SpecialTo=true",
    //            cache: false,
    //            success: function (dt) {

    //                $(".LastViewedProducts.AutoSetted").remove();

    //                if (dt != "") {

    //                    $(".AutoGetLastVisited").append(dt);

    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
    //                    $(".LastViewedProducts .ProductList .Prd:gt(3)").addClass("hidden-sm");

    //                    if ($(".LastViewedProducts .ProductList .Prd").length >= 6) {
    //                        $(".AutoGetLastVisited").show();
    //                    }

    //                }

    //            }
    //        });
    //    }
    //}

    //GetLastVisitedProducts();

    //homebannerFull2

    //$(".E-BulletinButton2").live("click", function myfunction() {
    //    var email = $('#NewsletterEposta').val();
    //    if (email !== "" && email !== undefined) {
    //        if (document.getElementById('AllowTerms').checked) {
    //            $("#NewsletterModal").modal("show");
    //            $("#NewsletterModal #hiddenEmail").html("<input type='hidden' id='email' name='email' value='" + email + "' />")

    //            $('.NewsLetterResult').addClass('gizli');
    //            $('.NewsLetterResult').html("");

    //        } else {
    //            $('.NewsLetterResult').removeClass('gizli');
    //            $('.NewsLetterResult').html("Fırsatlardan haberdar olmak istiyorsan Açık Rıza onayı vermelisin.");
    //        }
    //    } else {
    //        $('.NewsLetterResult').removeClass('gizli');
    //        $('.NewsLetterResult').html("Lütfen mail adresinizi giriniz.");
    //    }
    //});

    $(".subscribeNewsletter").live("click", function () {
        var name = $("#name").val();
        var surName = $("#surName").val();
        var emailSubscripeType = $("#EmailSubscripeType").val();
        var email = $("#NewsletterEposta").val();
        var allowTerms = document.getElementById('AllowTerms').checked;
        var allowKVKK = document.getElementById('AllowKVKK').checked

        if (email !== "" && email !== undefined) {
            if (allowTerms && allowKVKK) {
                $("#NewsletterModal").modal("show");
                $("#NewsletterModal #hiddenEmail").html("<input type='hidden' id='email' name='email' value='" + email + "' />")

                $('.NewsLetterResult').addClass('gizli');
                $('.NewsLetterResult').html("");

                $.ajax({
                    type: "GET",
                    url: "/" + $("#SmallLangCode").val() + "/p/User/EmailSubscribe?email=" + email + "&name=" + name + "&EmailSubsType=" + emailSubscripeType + "&surName=" + surName,
                    cache: false,
                    success: function (dt) {
                        if (dt.Sonuc == true) {
                            $('.NewsLetterResult').addClass('gizli');
                            $(".NewsLetterResultModal").removeClass("gizli ");
                            $(".NewsLetterResultModal").html("<div><span class='closeAlert'>x</span><div class='alertHead'>TEŞEKKÜRLER!</div>" + dt.IslemSonucAciklama + "</div>");
                        }
                        else {
                            $(".NewsLetterResultModal").removeClass("gizli ");
                            $(".NewsLetterResultModal").html("<div><span class='closeAlert'>x</span>" + dt.IslemSonucAciklama + "</div>");
                        }
                    }
                });

            } else {
                $('.NewsLetterResult').removeClass('gizli');
                if (!allowKVKK && !allowTerms) {
                    $('.NewsLetterResult').html("Fırsatlardan haberdar olmak istiyorsanız Açık Rıza onayı vermeli ve Kvkk aydınlatma metnini kabul etmelisiniz.");
                } else if (!allowKVKK) {
                    $('.NewsLetterResult').html("Fırsatlardan haberdar olmak istiyorsanız Kvkk aydınlatma metnini kabul etmelisiniz.");
                } else {
                    $('.NewsLetterResult').html("Fırsatlardan haberdar olmak istiyorsanız Açık Rıza onayı vermelisiniz.");
                }
            }
        } else {
            $('.NewsLetterResult').removeClass('gizli');
            $('.NewsLetterResult').html("Lütfen mail adresinizi giriniz.");
        }
    });

    $(document).on("click", ".closeAlert", function () {
        $(".NewsLetterResultModal").addClass("gizli ");
    });

    // video mute unmute play pause olayları
    $(document).on("click", ".js-video-unmute", function () {

        $('.js-video-mute').show();
        $('.js-video-unmute').hide();

        $(".video-banner").prop('muted', true);
        $("#video1").prop('muted', true);
    });

    $(document).on("click", ".js-video-mute", function () {
        $('.js-video-mute').hide();
        $('.js-video-unmute').show();

        $(".video-banner").prop('muted', false);
        $("#video1").prop('muted', false);
    });

    var video = document.getElementsByClassName("video-banner")[0];

    $(document).on("click", "#playPauseBtn", function () {
        if (video.paused) {
            video.play();
            $(this).html('<span class="glyphicon glyphicon-pause"></span>');
        } else {
            video.pause();
            $(this).html('<span class="glyphicon glyphicon-play"></span>');
        }
    });

    //if ($(".cookie-information-wrapper").length > 0) {
    //    var cookieName = 'JmkCookie_Notif280518';
    //    var cookieValue = 'JmkCookie_val280518';

    //    if (getCookie(cookieName) == "") {
    //        $(".cookie-information-wrapper").addClass("show");
    //    }
    //    else {
    //        $(".cookie-information-wrapper").remove();
    //    }

    //    $(document).on("click", ".js-cookie-accept", function () {
    //        setCookie(cookieName, cookieValue);

    //        $(".cookie-information-wrapper").removeClass("show");

    //        setTimeout(function () {
    //            $(".cookie-information-wrapper").remove();
    //        }, 1000);
    //    });

    //    $(document).on("click", "#CookieTimesCloseButton", function () {
    //        $(".cookie-information-wrapper").removeClass("show");
    //    });
    //}

    if ($("#link-button-1454703860695").length > 0) {
        console.log('WhatsApp ve SMS Opt-In butonu bulundu, event listener eklendi');
        document.getElementById('link-button-1454703860695').addEventListener('click', function () {
            console.log('WhatsApp ve SMS Opt-In işlemi başlatıldı');
            var phoneNumber = document.getElementById('ins-dynamic-phone-1578670408404').value;
            var allowWhatsapp = document.getElementById('ins-whatsapp-input-1578670408402').checked;
            var allowSms = document.getElementById('ins-sms-input-1578670408405').checked;

            sendOptInData(phoneNumber, allowWhatsapp, allowSms);
        });
    }

    function sendOptInData(phoneNumber, allowWhatsapp, allowSms) {
        console.log('sendOptInData fonksiyonu çağrıldı');
        var sessionId = getCookie('SessionID');

        if (!sessionId) {
            sessionId = generateUUID();
            setCookie('SessionID', sessionId, 5);
            console.log('Yeni SessionID oluşturuldu:', sessionId);
        }
        console.log('Opt-in verileri gönderiliyor:', phoneNumber, allowWhatsapp, allowSms, sessionId);

        fetch('/Home/UpdateUserPreferences', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                PhoneNumber: phoneNumber,
                AllowWhatsapp: allowWhatsapp,
                AllowSms: allowSms,
                SessionID: sessionId
            })
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                if (data.success) {
                    console.log('Başarıyla güncellendi:', data.message);


                } else {
                    console.error('Güncelleme başarısız:', data.message);
                }
            })
            .catch(function (error) {
                console.error('Güncelleme sırasında hata oluştu:', error);
            });
    }


    function sendOptInEmailData(mail) {
        console.log('sendOptInEmailData fonksiyonu çağrıldı');
        var sessionId = getCookie('SessionID');

        if (!sessionId) {
            sessionId = generateUUID();
            setCookie('SessionID', sessionId, 5);
            console.log('Yeni SessionID oluşturuldu:', sessionId);
        }
        console.log('Email opt-in verileri gönderiliyor:', 'Email:' + mail, 'SessionID:' + sessionId);

        fetch('/Home/UpdateUserEmailPreferences', {

            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Email: mail,
                SessionID: sessionId
            })
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Sunucu hatası: ' + response.status);
                }
                return response.json();
            })
            .then(function (data) {
                if (data.success) {
                    console.log('Email onayı başarıyla güncellendi:', data.message);

                } else {
                    console.error('Email onayı güncelleme başarısız:', data.message);
                }
            })
            .catch(function (error) {
                console.error('Email onayı güncelleme sırasında hata oluştu:', error.message);
            });
    }

    if ($("#link-button-16528107399650").length > 0) {
        console.log('Email Opt-In butonu bulundu, event listener eklendi');
        document.getElementById('link-button-16528107399650').addEventListener('click', function () {
            console.log('Email Opt-In işlemi başlatıldı');
            var emailData = $("#ins-dynamic-email-15452221711090").val();

            if (emailData) {
                console.log('Email verisi bulundu, sendOptInEmailData fonksiyonu çağrılıyor');
                sendOptInEmailData(emailData);
            }
            else {
                console.log('Email verisi bulunamadı');
            }
        });
    }
});

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cookieName, cookieValue) {
    var expiresDate = new Date();

    expiresDate.setTime(expiresDate.getTime() + 1000 * 36000);

    $.cookie(cookieName, cookieValue, { path: '/', expires: 365 });
}

function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
